import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ClassicSiteAuthProvider } from "./auth";
import ClassicSiteLayout from "./components/ClassicSiteLayout";
import MemberRouteGuard from "./components/MemberRouteGuard";
import ClassicSiteHomePage from "./pages/ClassicSiteHomePage";
import PublicListingsPage from "./pages/public/PublicListingsPage";
import PublicListingDetailPage from "./pages/public/PublicListingDetailPage";
import PublicEventsPage from "./pages/public/PublicEventsPage";
import PublicPromosPage from "./pages/public/PublicPromosPage";
import MemberHomePage, {
  MemberAccountPage,
  MemberBillingPage,
  MemberProfilePage,
  MemberSubscriptionsPage,
  MemberSubscriptionChoosePage,
  MemberListingsPage,
  MemberListingNewPage,
  MemberListingDetailPage,
  MemberAuthPage,
  MemberListingEventsPage,
  MemberListingPromosPage,
} from "./pages/member/MemberPages";
import AdminHomePage, {
  AdminListingsPage,
  AdminTagsPage,
  AdminTagGroupingsPage,
  AdminSocialGroupsPage,
  AdminEventsPage,
  AdminPromosPage,
  AdminGenericBlockedPage,
} from "./pages/admin/AdminPages";
import ApiCapabilitiesPage from "./pages/diagnostics/ApiCapabilitiesPage";
import StagingVerificationPage from "./pages/diagnostics/StagingVerificationPage";
import ClassicSiteLoginPage from "./pages/ClassicSiteLoginPage";

export default function ClassicSiteRoutes() {
  return (
    <ClassicSiteAuthProvider>
      <Routes>
        <Route element={<ClassicSiteLayout />}>
          <Route index element={<ClassicSiteHomePage />} />

          <Route path="public/listings" element={<PublicListingsPage />} />
          <Route path="public/listings/:id" element={<PublicListingDetailPage />} />
          <Route path="public/events" element={<PublicEventsPage />} />
          <Route path="public/promos" element={<PublicPromosPage />} />

          <Route path="diagnostics/api-capabilities" element={<ApiCapabilitiesPage />} />
          <Route
            path="diagnostics/staging-verification"
            element={<StagingVerificationPage />}
          />

          <Route path="login" element={<ClassicSiteLoginPage />} />

          <Route path="member" element={<MemberRouteGuard />}>
            <Route index element={<MemberHomePage />} />
            <Route path="account" element={<MemberAccountPage />} />
            <Route path="billing" element={<MemberBillingPage />} />
            <Route path="profile" element={<MemberProfilePage />} />
            <Route path="subscriptions" element={<MemberSubscriptionsPage />} />
            <Route
              path="subscriptions/choose"
              element={<MemberSubscriptionChoosePage />}
            />
            <Route path="listings" element={<MemberListingsPage />} />
            <Route path="listings/new" element={<MemberListingNewPage />} />
            <Route path="listings/:id" element={<MemberListingDetailPage />} />
            <Route
              path="listings/:id/events"
              element={<MemberListingEventsPage />}
            />
            <Route
              path="listings/:id/promos"
              element={<MemberListingPromosPage />}
            />
            <Route path="auth" element={<MemberAuthPage />} />
            <Route path="auth/choose" element={<MemberAuthPage />} />
          </Route>

          <Route path="admin" element={<AdminHomePage />} />
          <Route path="admin/listings" element={<AdminListingsPage />} />
          <Route path="admin/listings/:id" element={<AdminListingsPage />} />
          <Route path="admin/events" element={<AdminEventsPage />} />
          <Route path="admin/events/:id" element={<AdminEventsPage />} />
          <Route path="admin/promos" element={<AdminPromosPage />} />
          <Route path="admin/promos/:id" element={<AdminPromosPage />} />
          <Route path="admin/tags" element={<AdminTagsPage />} />
          <Route path="admin/tag-groupings" element={<AdminTagGroupingsPage />} />
          <Route path="admin/social-groups" element={<AdminSocialGroupsPage />} />
          <Route
            path="admin/users"
            element={<AdminGenericBlockedPage slug="users" />}
          />
          <Route
            path="admin/users/:id"
            element={<AdminGenericBlockedPage slug="users" />}
          />
          <Route
            path="admin/subscription-users"
            element={<AdminGenericBlockedPage slug="subscription-users" />}
          />
          <Route
            path="admin/members"
            element={<AdminGenericBlockedPage slug="members" />}
          />
          <Route
            path="admin/members/:id"
            element={<AdminGenericBlockedPage slug="members" />}
          />
          <Route
            path="admin/phone-numbers"
            element={<AdminGenericBlockedPage slug="phone-numbers" />}
          />
          <Route
            path="admin/coupons"
            element={<AdminGenericBlockedPage slug="coupons" />}
          />
          <Route
            path="admin/announcements"
            element={<AdminGenericBlockedPage slug="announcements" />}
          />
          <Route
            path="admin/listing-flags"
            element={<AdminGenericBlockedPage slug="listing-flags" />}
          />

          <Route path="*" element={<Navigate to="." replace relative="path" />} />
        </Route>
      </Routes>
    </ClassicSiteAuthProvider>
  );
}
